<template>
    <popup v-model="innerShow" position="bottom">
        <div class="district-detail">
            <div class="toolbar">
                <span @click="onCancel">{{ $t('buttons.cancel') }}</span>
                <span @click="onConfirm">{{ $t('buttons.confirm') }}</span>
            </div>

            <section class="address-nav">
                <div @click.stop="selectedCity"><span>{{ tempSelectCity || $t('hint.chooseCity') }}</span></div>
                <div @click="itemState=1" v-if="itemState>0"><span>{{
                        tempSelectDistrict || $t('hint.chooseRegion')
                    }}</span></div>
            </section>

            <div class="address-main">
                <div class="first-letter" v-if="itemState === 0">
                    <div v-for="(item,index) in firstLetterList" :key="index" @click="selectedIndex(item)">{{ item }}
                    </div>
                </div>
                <div class="loading-container" v-if="isLoading">
                    <div>
                        <loading :text="$t('comm.getting')" :message="errMsg"/>
                    </div>
                </div>
                <ul v-else class="select-list">
                    <li v-if="itemState === 0">
                        <div class="scroll-list">
                            <div v-for="(item,letter) in cityList" :key="letter" :ref="letter" class="own-anchor">
                                <div v-for="row in item" :key="row.cityCode"
                                     @click="changeCity(row)"
                                     :class="{focus:row.cityName == lightCity,'big-focus':row.cityName == anchorIndex}">
                                    {{ row.cityName }}
                                </div>
                            </div>
                        </div>
                    </li>
                    <li v-if="itemState === 1">
                        <div v-for="district in districtList" :key="district.districtCode"
                             :class="{focus:district.districtName == tempSelectDistrict,'area-cell': true }"
                             @click="changeDistrict(district)">
                            {{ district.districtName }}
                        </div>
                    </li>
                </ul>
            </div>
            <!-- <picker ref="picker" class="picker"
                    title=""
                    value-key="name"
                    :loading="isLoading"
                    :columns="columns"
                    @change="onChange"
            /> -->
        </div>
    </popup>
</template>

<script>
import popup from '@components/popup'
import {Loading, Picker, Toast} from 'vant';
// 门店处理
import storeModel, {getStoreCityList, getDistrictList, normalizeCityList} from "@comm/store/store.model"

export default {
    name: 'district-popup',
    components: {
        popup,
        Loading,
        Picker,
    },
    model: {
        prop: 'show',
        event: 'show'
    },
    props: {
        // 是否展示
        show: {
            type: Boolean,
            default: false
        },
        // 是否展示
        isAll: {
            type: Boolean,
            default: false
        },
        city: {
            type: String,
            default: ''
        },
        district: {
            type: String,
            default: ''
        },
    },
    mounted() {

    },
    computed: {
        selectCity() {
            return this.tempSelectCity || storeModel.getters.selectCityName || this.addressInfo.province
        },
        selectDistrict() {
            return this.tempSelectDistrict || storeModel.getters.selectDistrictName || this.addressInfo.district
        },
    },
    data() {
        return {
            isLoading: true,
            innerShow: this.show,
            values: [],
            cityList: [],
            districtList: [],
            addressInfo: {},
            tempSelectCity: this.city,
            tempSelectDistrict: this.district,
            columns: [
                {
                    values: [],
                    className: 'column1'
                },
                {
                    values: [],
                    className: 'column2',
                }
            ],
            // 选项状态
            itemState: 0,
            // 错误信息容器
            errMsg: '',
            // 首字母列表
            firstLetterList: [],
            // 城市高亮
            anchorIndex: '',
            // 选中的城市高亮
            lightCity: '',
        }
    },
    methods: {
        init() {
            // 获取城市列表
            getStoreCityList().then(cityList => {
                this.cityList = normalizeCityList(cityList);
                // 字母列表
                if (this.cityList) this.firstLetterList = Object.keys(this.cityList);
                this.isLoading = false;
                // 获取区域列表信息
                if (this.tempSelectDistrict) this.getDistrictList((cityList.find(cityInfo => cityInfo.cityName == this.selectCity) || cityList[0]).cityCode, this.isAll)
            }, errMsg => {
                this.errMsg = errMsg;
            })
            return
            // 检查是否加载状态，否则进行重重
            if (!this.isLoading) return this.$nextTick(() => this.resetLoaction());
            // 获取所选地区门店列表
            getStoreCityList().then(cityList => {
                this.cityList = cityList;
                // 获取区域列表
                return getDistrictList((cityList.find(cityInfo => cityInfo.cityName == this.selectCity) || cityList[0]).cityCode, this.isAll);
            }).catch(err => {
                this.errMsg = err;
            }).then(districtList => {
                this.isLoading = false;
                // 赋值已选的区域信息
                this.setColumns(0, this.cityList);
                this.setColumns(1, districtList);
                this.resetLoaction();
            });
        },
        // 城市选择
        changeCity(info) {
            if (!info) return
            this.tempSelectCity = info.cityName;

            // 获取并切换区域列表
            this.getDistrictList(info.cityCode, this.isAll);
        },
        getDistrictList(cityCode) {
            this.isLoading = true;
            getDistrictList(cityCode, this.isAll).then(res => {
                this.districtList = res;
                this.isLoading = false;
                this.itemState = 1;
            }, errMsg => {
                this.errMsg = errMsg;
            });
        },
        // 跳转到字母对应列表
        toLetterFun() {
            this.$nextTick(() => {
                if (this.itemState == 0) {
                    let tempLetter = (Object.values(this.cityList).flat().find(item => item.cityName == this.tempSelectCity) || {}).cityCharAt0;
                    if (this.$refs[tempLetter] && tempLetter) this.$refs[tempLetter][0].scrollIntoView();
                }
            })

        },
        selectedCity() {
            this.lightCity = ''; //点击索引栏清空选中城市的高亮
            this.tempSelectDistrict = ''; //清空区域名称
            // 切换到城市时候当前城市高亮
            if (this.itemState = 1) {
                if (this.anchorIndex != this.tempSelectCity) this.anchorIndex = this.tempSelectCity
            }
            this.itemState = 0;
            this.toLetterFun();
        },
        // 点击索引栏的字符时触发
        selectedIndex(index) {
            this.lightCity = ''; //点击索引栏清空选中城市的高亮
            this.$nextTick(() => {
                // 点击字母定位到符合条件的地方
                if (this.$refs[index]) this.$refs[index][0].scrollIntoView();
                Toast(index);
                // 定位到符合条件字符的第一个城市
                let tempCityName = (Object.values(this.cityList).flat().find(item => item.cityCharAt0 == index) || {}).cityName
                if (tempCityName) this.anchorIndex = tempCityName
            })
        },
        // 区域选择
        changeDistrict(info) {
            if (!info) return
            this.tempSelectDistrict = info.districtName;
        },

        setColumns(locaction, resList) {
            const picker = this.$refs.picker;
            this.districtList = resList;
            // 设置picker组件中的数值
            picker.setColumnValues(locaction, this.columns[locaction].values = resList.map(info => {
                return {
                    name: info.districtName || info.cityName,
                    value: info.districtCode || info.cityCode
                }
            }));
        },
        onCancel() {
            // 如果没有选择区域将区域置空
            if (!this.tempSelectDistrict) this.tempSelectDistrict = '';
            this.innerShow = false;
        },
        onConfirm() {
            // 如果没有选择区域将区域置空
            if (!this.tempSelectDistrict) this.tempSelectDistrict = '';
            // 修改事件抛出
            this.$emit('change', {
                city: {name: this.tempSelectCity},
                district: {name: this.tempSelectDistrict},
            })
            // 关闭浮层
            this.innerShow = false;
            return
            let values = this.$refs.picker.getValues();
            // 存储选择的门店所属地址
            this.tempSelectCity = values[0].name
            this.tempSelectDistrict = values[1].name

            // 修改事件抛出
            this.$emit('change', {
                city: values[0],
                district: values[1],
            })
            // 关闭浮层
            this.innerShow = false;
        },
        // picker选择的事件处理
        onChange(picker, values, locaction) {
            return new Promise((resolve, reject) => {
                if (!locaction) {
                    this.isLoading = true;
                    // 获取区域列表
                    getDistrictList(values[0].value, this.isAll).then(resList => {
                        this.setColumns(1, resList);
                        this.isLoading = false;
                        resolve(true);
                    })
                } else {
                    resolve(false);
                }
            })
        },
        // 重置选择的位置（定位之前选的位置）
        resetLoaction() {
            const picker = this.$refs.picker;
            // 城市信息
            const cityInfo = this.cityList.find(info => info.cityName == this.selectCity) || this.cityList[0];
            // 设置城市选择的索引
            picker.setColumnIndex(0, this.cityList.findIndex(info => info.cityName == this.selectCity));
            // 触发picker选择的事件处理
            this.onChange(picker, [{
                name: cityInfo.cityName,
                value: cityInfo.code || cityInfo.cityCode
            }]).then(() => {
                // 设置区域选择的索引
                picker.setColumnIndex(1, this.districtList.findIndex(info => info.districtName == this.selectDistrict));
            });
        }
    },
    watch: {
        innerShow(val) {
            this.anchorIndex = '';
            this.$emit('show', val);
            if (val) this.lightCity = this.tempSelectCity
            if (val && this.itemState == 0) {
                setTimeout(() => {
                    this.toLetterFun();
                }, 500);
            }
        },
        show(val) {
            if (this.innerShow = val) {
                this.init();
            }
        },
        city(val) {
            this.tempSelectCity = val;
        },
        district(val) {
            if (this.tempSelectDistrict) this.tempSelectDistrict = val;
        },
        itemState(val) {
            switch (val) {
                case 0:
                    this.tempSelectDistrict = '';
                    this.tempSelectCity = this.tempSelectCity || ''
                case 1:
                    this.tempSelectDistrict = this.tempSelectDistrict || ''
            }
        },

    }
}
</script>

<style lang="scss" scoped>
.district-detail {
    background-color: #fff;
    padding: 10px 0;
    box-sizing: border-box;
}

.toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: white;
    border-bottom: 0.5px solid #eee;

    span {
        height: 40px;
        color: #1989fa;
        padding: 0 15px;
        display: flex;
        font-size: 14px;
        font-weight: 500;
        align-items: center;
        justify-content: center;
    }
}

.address-main {
    height: calc(100vh - 350px);
    position: relative;
}

.address-nav, .address-main {
    padding: 0 10px;
}

.address-nav {
    height: 35px;
    display: flex;
    border-bottom: solid 1px #efeded;

    div {
        height: 100%;
        display: flex;
        padding-right: 20px;
        align-items: center;

        span {
            display: flex;
            height: 100%;
            align-items: center;
        }

        &:last-child {
            span {
                color: red;
                border-bottom: solid 1px red;
            }
        }
    }
}

.loading-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    > div {
        height: 200px;
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    p {
        color: #9c9c9c;
        font-size: 14px;
        padding-top: 20px;
        text-align: center;
    }
}

.first-letter {
    width: 37px;
    height: 100%;
    overflow-y: scroll;
    position: absolute;
    top: 10px;
    right: 0;
    padding: 10px;
    z-index: 99;
    text-align: center;

    div {
        padding-bottom: 6px;
        font-size: 12px;
    }

}

.select-list {
    width: 100%;
    padding: 0 10px;
    height: calc(100vh - 350px);
    overflow-y: scroll;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 50%;
    -webkit-transform: translate3d(-50%, 0, 0) !important;
    transform: translate3d(-50%, 0, 0) !important;
    -webkit-transition: .35s ease-out !important;
    transition: .35s ease-out !important;

    li {
        &.focus {
            color: #c52323;
        }

        .own-anchor {
            width: calc(100% - 37px);

            div {
                padding: 10px 0;

                &.big-focus, &.focus {
                    color: #333;
                    font-weight: bold;
                }
            }
        }

        .area-cell {
            padding: 10px 0;

            &.focus {
                color: #c52323;
            }
        }
    }

}
</style>